/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react';
import { Row, Input, Label, Badge, Card, Spinner, Col, CardHeader, FormGroup, CardBody, CardTitle, Modal, ModalBody, ModalHeader, ModalFooter, Button, Container, Form } from 'reactstrap';
import axios from 'axios';
import { Link } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "./Style.css";
import MobileHeader from 'components/Headers/MobileHeader';
import { getAddressMap } from "utils/getMapAddress";

const SalesPage = () => {
    const token = localStorage.token;
    const userid = localStorage.uic;
    const trackingcode = localStorage.tc;
    const username = localStorage.username;
    const warehouseId = localStorage.warehouse;
    // const redirectPrefix = `/mobile/canvasing/detail/`;
    const [long, setLong] = useState(null);
    const [lat, setLat] = useState(null);
    const [buttonsales, setButtonSales] = useState("");
    const [name, setName] = useState("");
    const [picture, setPicture] = useState("");
    const [jabatan, setJabatan] = useState("");
    const [address, setAddress] = useState("");
    const [allDocument, setAllDocument] = useState([]);
    // const [tanggal, setTanggal] = useState("");
    const [intervalId, setIntervalId] = useState(null);
    // const [trackingCode, setTrackingCode] = useState(localStorage.getItem("tc") || "");
    const [trackLog, setTrackLog] = useState([]);
    const [trackPause, setTrackPause] = useState([]);
    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading4, setLoading4] = useState(false)
    const [loadings, setLoadings] = useState(false)
    const latRef = useRef(null);
    const longRef = useRef(null);
    const addressRef = useRef(null);
    const trackingCodeRef = useRef(trackingcode);
    const [canResume, setCanResume] = useState(true);
    const [buttonactive, setButtonActive] = useState(1);
    const [modalTutorialCanvasing, setModalTutorialCanvasing] = useState(false);

    const [isItemModalOpen, setIsItemModalOpen] = useState(false);
    const [isItemModalOpen1, setIsItemModalOpen1] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false); // State untuk loading
    const [searchError, setSearchError] = useState(null);   // State untuk error

    const [searchQuery1, setSearchQuery1] = useState('');
    const [searchResults1, setSearchResults1] = useState([]);
    const [isSearching1, setIsSearching1] = useState(false); // State untuk loading
    const [searchError1, setSearchError1] = useState(null);   // State untuk error

    const headers = { Authorization: `Bearer ${token}` };

    const toggleItemModal = () => setIsItemModalOpen(!isItemModalOpen);
    const toggleItemModal1 = () => setIsItemModalOpen1(!isItemModalOpen1);

    // === useEffect dengan Debouncing & Axios ===
    useEffect(() => {
        // Jika input kosong, reset semuanya
        if (searchQuery.trim() === '') {
            setSearchResults([]);
            setIsSearching(false);
            setSearchError(null);
            return;
        }

        // Mulai loading
        setIsSearching(true);
        setSearchError(null);

        const getData = setTimeout(() => {
            // Pastikan warehouse_id dan headers tersedia
            if (!warehouseId || !headers) {
                setSearchError("Konfigurasi tidak lengkap (Warehouse/Headers).");
                setIsSearching(false);
                return;
            }

            axios
                .post(`${process.env.REACT_APP_API_BASE_URL}/items-so-proyek`, {
                    item_info: searchQuery,
                    page: 1,
                    per_page: 10,
                    warehouse_id: parseInt(warehouseId)
                }, { headers })
                .then((res) => {
                    // Sesuaikan dengan struktur respons API Anda
                    // Contoh: res.data.response atau res.data.data
                    setSearchResults(res.data.response || []);
                })
                .catch((error) => {
                    console.error("Error fetching items:", error);
                    const errorMessage = error.response?.data?.message || "Terjadi kesalahan saat mencari item.";
                    setSearchError(errorMessage);
                    setSearchResults([]);
                })
                .finally(() => {
                    // Hentikan loading setelah selesai
                    setIsSearching(false);
                });
        }, 1000); // Delay 1 detik

        // Cleanup function untuk membatalkan timeout jika user mengetik lagi
        return () => clearTimeout(getData);

    }, [searchQuery, warehouseId]); // <-- Tambahkan dependencies

    useEffect(() => {
        // Jika input kosong, reset semuanya
        if (searchQuery1.trim() === '') {
            setSearchResults1([]);
            setIsSearching1(false);
            setSearchError1(null);
            return;
        }

        // Mulai loading
        setIsSearching1(true);
        setSearchError1(null);

        const getData = setTimeout(() => {
            // Pastikan warehouse_id dan headers tersedia
            if (!warehouseId || !headers) {
                setSearchError1("Konfigurasi tidak lengkap (Warehouse/Headers).");
                setIsSearching1(false);
                return;
            }

            axios
                .post(`${process.env.REACT_APP_API_BASE_URL}/canvasing-parent/page`, {
                    customer_name: searchQuery1,
                    page: 1,
                    per_page: 10,
                    username: username,
                    warehouse_id: parseInt(warehouseId)
                }, { headers })
                .then((res) => {
                    // Sesuaikan dengan struktur respons API Anda
                    // Contoh: res.data.response atau res.data.data
                    setSearchResults1(res.data.response || []);
                })
                .catch((error) => {
                    console.error("Error fetching items:", error);
                    const errorMessage = error.response?.data?.message || "Terjadi kesalahan saat mencari item.";
                    setSearchError1(errorMessage);
                    setSearchResults1([]);
                })
                .finally(() => {
                    // Hentikan loading setelah selesai
                    setIsSearching1(false);
                });
        }, 1000); // Delay 1 detik

        // Cleanup function untuk membatalkan timeout jika user mengetik lagi
        return () => clearTimeout(getData);

    }, [searchQuery1, warehouseId]); // <-- Tambahkan dependencies


    useEffect(() => {
        latRef.current = lat;
    }, [lat]);

    useEffect(() => {
        longRef.current = long;
    }, [long]);

    useEffect(() => {
        addressRef.current = address;
    }, [address]);

    useEffect(() => {
        trackingCodeRef.current = trackingcode;
    }, [trackingcode]);

    const sendTrackingUpdate = async (flag) => {
        setLoading(true)
        const latNow = latRef.current;
        const longNow = longRef.current;
        const addressNow = addressRef.current;
        const trackCode = trackingCodeRef.current;

        if (!latNow || !longNow || !username || !addressNow || !trackCode) {
            return;
        }

        // const now = new Date(); 
        // const formattedDate = now.toLocaleString("en-GB", {
        //     day: "2-digit", month: "2-digit", year: "numeric",
        //     hour: "2-digit", minute: "2-digit", second: "2-digit"
        // }).replace(",", "");

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        const logData = { address: addressNow, longitude: longNow, latitude: latNow };

        const payload = {
            warehouse_id: parseInt(warehouseId),
            username,
            track_asal: null,
            // track_akhir: flag === 1 ? logData : "",
            track_akhir: null,
            active_flag: 1,
            track_log: flag === 1 ? [...trackLog, logData] : [],
            track_berhenti: null,
        };

        if (flag === 1) {
            setTrackLog((prev) => [...prev, logData]);
        } else if (flag === 3) {
            setTrackPause((prev) => [...prev, logData]);
        }

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/sales-track/update?code=${trackCode}`, payload, { headers })
            .then((res) => {
                // console.log("📍 Tracking updated", res.data);
                setLoading(false)
                setLoading3(false)
                getCekSalesTrack()
            })
            // .catch((err) => console.error("❌ Gagal update tracking", err));
            .catch(function (error) {
                setLoading(false)
                setLoading3(false)

                // setGagalAlert(error.response.data.message);
            });
    };

    const handleHoldTracking = (flag) => {
        setLoading2(true)
        clearInterval(intervalId);
        setIntervalId(null);
        const latNow = latRef.current;
        const longNow = longRef.current;
        const addressNow = addressRef.current;
        const trackCode = trackingCodeRef.current;

        if (!latNow || !longNow || !username || !addressNow || !trackCode) {
            return;
        }

        // const now = new Date();

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        const logData = { address: addressNow, longitude: longNow, latitude: latNow };

        const payload = {
            warehouse_id: parseInt(warehouseId),
            username,
            track_asal: null,
            track_akhir: null,
            active_flag: 3,
            track_log: null,
            track_berhenti: [...trackPause, logData],
        };

        if (flag === 3) {
            setTrackPause((prev) => [...prev, logData]);
        }

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/sales-track/update?code=${trackCode}`, payload, { headers })
            .then((res) => {
                // console.log("📍 Tracking Berhenti", res.data);
                getCekSalesTrack()
                setLoading2(false)

            })
            // .catch((err) => console.error("❌ Gagal update tracking", err));
            .catch(function (error) {
                setLoading2(false)
            });
    };

    const handleStopTracking = () => {
        setLoading4(true)
        clearInterval(intervalId);
        setIntervalId(null);
        const trackCode = trackingCodeRef.current;
        if (!trackCode) {
            // console.warn("⛔ Data belum lengkap, tracking tidak dikirim");
            return;
        }

        // const now = new Date();

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        const payload = {
            warehouse_id: parseInt(warehouseId),
            username,
            track_asal: null,
            track_akhir: {
                address: address,
                longitude: long,
                latitude: lat,
            },
            active_flag: 2,
            track_log: null,
            track_berhenti: null,
        };

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/sales-track/update?code=${trackCode}`, payload, { headers })
            .then((res) => {
                // console.log("📍 Tracking Selesai", res.data);
                getCekSalesTrack()
                setLoading4(false)
            })
            .catch(function (error) {
                setLoading4(false)
            });
    };

    const handleResumeTracking = () => {
        setLoading3(true)
        sendTrackingUpdate(1); // kirim awal lanjut
        getCekSalesTrack()
    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // bulan dimulai dari 0
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getAllDokument = (page, search_date = null) => {
        const today = getTodayDate(); // Ambil tanggal hari ini
        const filter = {
            page: 1,
            per_page: 50,
            start_date: today,
            end_date: today,
            warehouse_id: parseInt(warehouseId),
            username: username,
        };

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .post(
                `${process.env.REACT_APP_API_BASE_URL}/canvasing/page`,
                filter,
                { headers }
            )
            .then((res) => {
                const responseData = res.data.response || [];
                setAllDocument(responseData);
                // console.log("rfq_flag semua dokumen:", responseData.map(doc => doc.rfq_flag));

                // Cek apakah semua rfq_flag === 1 → hide tombol resume
                const isAllOne = responseData.length > 0 && responseData.every(doc => doc.rfq_flag === 1);
                const isAllTwo = responseData.length > 0 && responseData.every(doc => doc.rfq_flag === 2);

                if (isAllOne) {
                    setCanResume(true);
                } else if (isAllTwo) {
                    setCanResume(true);
                } else {
                    setCanResume(true); // fallback untuk kondisi campuran
                }

            })
            .catch((error) => {
                setAllDocument(error.response.data.response);
            });
    };

    useEffect(() => {
        getAllDokument();
    }, []);

    useEffect(() => {
        updateLocation(); // langsung update awal
        getByUser();
        getCekSalesTrack();
        const locationInterval = setInterval(() => {
            updateLocation();
        }, 20000); // update lokasi setiap 10 detik
        const salesTrackInterval = setInterval(() => {
            getCekSalesTrack();
        }, 500000); // cek status sales-track tiap 30 detik
        return () => {
            clearInterval(locationInterval);
            clearInterval(salesTrackInterval);
        };
    }, []);

    const updateLocation = async () => {
        navigator.geolocation.getCurrentPosition(async (position) => {
            const lat = position.coords.latitude;
            const long = position.coords.longitude;
            setLat(lat);
            setLong(long);
            const pointAddress = await getAddressMap(lat, long);
            setAddress(pointAddress?.display_name || "Alamat tidak ditemukan");
        });
    };

    const saveTrackData = () => {
        setLoading1(true)
        if (!lat || !long || !username || !address) return;

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        const payload = {
            warehouse_id: warehouseId,
            username: username,
            track_asal: {
                address: address,
                longitude: long,
                latitude: lat,
            },
            active_flag: 1,
        };

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/sales-track/save`, payload, { headers })
            .then((res) => {
                window.localStorage.setItem("tc", res.data.response.tracking_code);
                getCekSalesTrack()
                setLoading1(false)
            })
            .catch((error) => {
                // console.error("Gagal simpan data:", error.response?.data || error.message);
                setLoading1(false)

            });
    };

    const getCekSalesTrack = () => {
        setLoadings(true)

        if (!username) return;

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/sales-track/check-by-username/${username}`, { headers })
            .then((res) => {
                const isPresent = res.data.response.is_present;
                const lastactive = res.data.response.is_last_active;
                setLoadings(false)
                setButtonSales(isPresent);
                setButtonActive(lastactive);
                window.localStorage.setItem("tc", res.data.response.tracking_code);

                if (isPresent === 1) {
                    if (!intervalId) {
                        const id = setInterval(() => {
                            sendTrackingUpdate(1);
                        }, 500000);
                        setIntervalId(id);
                    }
                } else {
                    if (intervalId) {
                        clearInterval(intervalId);
                        setIntervalId(null);
                        setLoadings(false)
                    }
                }
            })
            .catch((error) => {
                // console.log("Gagal ambil status sales-track:", error);
            });
    };

    useEffect(() => {
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [intervalId]);

    const getByUser = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/users/profil/${userid}`, { headers })
            .then((res) => {
                const user = res.data.response;
                setName(user.name);
                setPicture(user.karyawan_image);
                setJabatan(user.jabatan);
            })
            .catch((error) => {
                // console.log("Gagal ambil profil:", error);
            });
    };


    return (
        <div>
            <MobileHeader name={name} picture={picture} jabatan={jabatan} />
            <Container className="mt--5" fluid>
                <Row>
                    {loadings ? (
                        // Tampilan loading saat data sedang dimuat
                        <div className="col d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                <p className="mt-2">Memuat data, tunggu sebentar...</p>
                            </div>
                        </div>
                    ) :
                        buttonsales === 1 || buttonsales === 3 ?
                            <>
                                <div className="col">
                                    <Card className="shadow-sm border-0">
                                        {/* Header */}
                                        <CardHeader className="d-flex justify-content-between align-items-center flex-wrap">
                                            {/* Judul kiri */}
                                            <h5 className="mb-0 font-weight-bold">📌 Kunjungan Hari Ini</h5>

                                            {/* Tombol kanan */}
                                            <div className="d-flex gap-2 mt-2 mt-sm-0">
                                                <Button
                                                    color="success"
                                                    size="sm"
                                                    onClick={toggleItemModal1}
                                                    className="d-flex align-items-center"
                                                >
                                                    <i className="fa fa-search mr-1" />
                                                    Customer
                                                </Button>

                                                <Button
                                                    color="success"
                                                    size="sm"
                                                    onClick={toggleItemModal}
                                                    className="d-flex align-items-center"
                                                >
                                                    <i className="fa fa-search mr-1" />
                                                    Harga
                                                </Button>
                                            </div>
                                        </CardHeader>



                                        <CardBody>
                                            {allDocument === null || allDocument.length === 0 ? (
                                                <div className="text-center py-4 text-muted">
                                                    <i className="fa fa-exclamation-circle fa-2x mb-2" />
                                                    <h6 className="mb-0">Data tidak ditemukan</h6>
                                                </div>
                                            ) : (
                                                <PerfectScrollbar>
                                                    <div
                                                        className="d-lg-none d-xl-none"
                                                        style={{ padding: "0.5rem", maxHeight: "35rem", overflowY: "auto" }}
                                                    >
                                                        <Form>
                                                            <div>
                                                                {allDocument.map((v) => {
                                                                    let badgeColor = "secondary";
                                                                    let badgeText = "Baru";
                                                                    let iconStatus = "fa-clock";
                                                                    let dynamicLink = "/mobile/canvasing/detail/" + v.canvasing_code;

                                                                    if (v.approve === 3 && v.active_flag === 1 && v.rfq_flag === 1) {
                                                                        badgeColor = "warning";
                                                                        badgeText = "Proses";
                                                                        iconStatus = "fa-hourglass-half";
                                                                        dynamicLink = "/mobile/canvasing/penawaran/" + v.canvasing_code;
                                                                    } else if (v.approve === 3 && v.active_flag === 1 && v.rfq_flag === 2) {
                                                                        badgeColor = "danger";
                                                                        badgeText = "Ditolak";
                                                                        iconStatus = "fa-times";
                                                                    } else if (v.approve === 4) {
                                                                        badgeColor = "danger";
                                                                        badgeText = "Ditolak";
                                                                        iconStatus = "fa-times";
                                                                    } else {
                                                                        badgeColor = "success";
                                                                        badgeText = "Selesai";
                                                                        iconStatus = "fa-check";
                                                                    }

                                                                    return (
                                                                        <Link to={dynamicLink} key={v.id}>
                                                                            <Card className="border-0 shadow-sm rounded-3 mb-3" style={{
                                                                                backgroundColor: "#daecffff", boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                                                                            }}>
                                                                                <CardBody className="p-3">
                                                                                    {/* Baris 1: Nama + Status */}
                                                                                    <Row className="align-items-center mb-2">
                                                                                        <Col xs="8" className="d-flex align-items-center">
                                                                                            <span
                                                                                                className="badge badge-primary mr-2"
                                                                                                style={{
                                                                                                    fontSize: "0.6rem",
                                                                                                    padding: "4px 8px",
                                                                                                    borderRadius: "8px",
                                                                                                    minWidth: "20px",
                                                                                                    textAlign: "center",
                                                                                                }}
                                                                                            >
                                                                                                {v.urutan ?? "-"}
                                                                                            </span>
                                                                                            <span className="font-weight-bold text-dark" style={{ fontSize: "0.8rem" }}>
                                                                                                {v.customer_name}
                                                                                            </span>
                                                                                        </Col>
                                                                                        <Col xs="4" className="text-right">
                                                                                            <span
                                                                                                className="badge badge-warning"
                                                                                                style={{ fontSize: "0.6rem", padding: "4px 8px", borderRadius: "8px" }}
                                                                                            >
                                                                                                PROSES
                                                                                            </span>
                                                                                        </Col>
                                                                                    </Row>

                                                                                    {/* Baris 2: Proyek */}
                                                                                    <div
                                                                                        className="text-muted mb-2"
                                                                                        style={{ fontSize: "0.75rem", fontWeight: "500" }}
                                                                                    >
                                                                                        {v.nama_proyek ?? "-"}
                                                                                    </div>

                                                                                    {/* Baris 3: Tanggal */}
                                                                                    <div className="text-muted mb-3" style={{ fontSize: "0.8rem" }}>
                                                                                        <i className="fa fa-calendar mr-1" />
                                                                                        {v.created_at ?? "Tanggal tidak tersedia"}
                                                                                    </div>

                                                                                    {/* Baris 4: Tombol Tambah full width */}
                                                                                    {v.rfq_flag === 1 && (
                                                                                        <Button
                                                                                            color="primary"
                                                                                            block
                                                                                            style={{
                                                                                                borderRadius: "10px",
                                                                                                fontSize: "0.85rem",
                                                                                                fontWeight: "500",
                                                                                                padding: "8px 0",
                                                                                            }}
                                                                                        >
                                                                                            <i className="fa fa-plus mr-1" /> Tambah Item
                                                                                        </Button>
                                                                                    )}
                                                                                </CardBody>
                                                                            </Card>

                                                                        </Link>
                                                                    );
                                                                })}
                                                            </div>
                                                        </Form>
                                                    </div>
                                                </PerfectScrollbar>
                                            )}
                                        </CardBody>
                                    </Card>
                                </div>

                                {buttonsales === 3 ?
                                    <>
                                        {canResume && (
                                            <div className="d-lg-none d-xl-none">
                                                <Button
                                                    disabled={loading3}
                                                    onClick={handleResumeTracking}
                                                    className="btn-warning text-center"
                                                    style={{
                                                        position: 'fixed',
                                                        bottom: 150,
                                                        right: 20,
                                                        height: 45,
                                                        width: 45,
                                                        borderRadius: 12,
                                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        zIndex: 1000,
                                                    }}
                                                >
                                                    {loading3 ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-play" style={{ fontSize: 20, color: '#fff' }} />
                                                        </>
                                                    )}
                                                </Button>
                                            </div>
                                        )}
                                        <div className="d-lg-none d-xl-none">
                                            <Link
                                                disabled={loading}
                                                to="/mobile/canvasing/create"
                                                className="btn-info text-center"
                                                style={{
                                                    position: 'fixed',
                                                    bottom: 100,
                                                    right: 20,
                                                    height: 45,
                                                    width: 45,
                                                    borderRadius: 12,
                                                    backgroundColor: '#00CFFF',
                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    zIndex: 1000,
                                                }}
                                            >
                                                <i className="fa fa-plus" style={{ fontSize: 28, color: '#fff' }} />
                                            </Link>
                                        </div>
                                    </>
                                    :
                                    buttonactive === 1 ?
                                        ""
                                        :
                                        <div className="d-lg-none d-xl-none">
                                            <Button
                                                disabled={loading2}
                                                onClick={() => handleHoldTracking(3)}
                                                className="btn-warning text-center"
                                                style={{
                                                    position: 'fixed',
                                                    bottom: 150,
                                                    right: 20,
                                                    height: 45,
                                                    width: 45,
                                                    borderRadius: 12,
                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    zIndex: 1000,
                                                }}
                                            >
                                                {loading2 ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-pause" style={{ fontSize: 20, color: '#fff' }} />
                                                    </>
                                                )}

                                            </Button>
                                        </div>
                                }
                            </>
                            :
                            <div
                                className="col d-flex justify-content-center align-items-center"
                                style={{ minHeight: "70vh", flexDirection: "column" }}
                            >
                                <div className="text-center mb-4">
                                    <h4 className="mb-3">
                                        Selamat datang di menu <strong>Sales Canvaser</strong>
                                    </h4>
                                </div>

                                {/* Container Tombol */}
                                <div className="d-flex gap-3">
                                    <Button
                                        color="primary"
                                        onClick={() => window.location.href = "/mobile/canvasing/history"}
                                        style={{
                                            padding: "10px 24px",
                                            borderRadius: "10px",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            minWidth: "140px"
                                        }}
                                    >
                                        📋 Riwayat
                                    </Button>

                                    <Button
                                        color="info"
                                        onClick={() => setModalTutorialCanvasing(true)}
                                        style={{
                                            padding: "10px 24px",
                                            borderRadius: "10px",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            minWidth: "140px"
                                        }}
                                    >
                                        ❓ Tutorial
                                    </Button>
                                </div>
                            </div>

                    }
                </Row>
            </Container >
            <nav className="navbar navbar-bottom bg-white navbar-expand fixed-bottom d-md-none d-lg-none d-xl-none">
                <ul className="navbar-nav nav-justified w-100 position-relative">
                    <li className="nav-item">
                        <a href="/mobile/staff-absen" className="nav-link text-center">
                            <i className="fas fa-home fa-lg d-block mb-1" />
                            <span className="small">Home</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <div className="fab-center-button">

                            {buttonsales === 2 && (
                                <div className="btn btn-warning rounded-circle p-0 d-flex justify-content-center align-items-center" style={{ height: "70px", width: "70px" }}>
                                    <i className="fa fa-times fa-2x" />
                                </div>
                            )}
                            {buttonsales === 0 && (
                                <Button
                                    color="success"
                                    disabled={loading1}
                                    onClick={() => saveTrackData()}
                                    className="rounded-circle p-0 d-flex justify-content-center align-items-center"
                                    style={{ height: "70px", width: "70px" }}
                                >
                                    <i className="fas fa-play fa-2x" />
                                </Button>
                            )}
                            {buttonactive === 0 || buttonactive === 1 ? (
                                buttonsales === 1 && (
                                    <Button
                                        color="danger"
                                        disabled={loading4}
                                        onClick={() => handleStopTracking()}
                                        className="rounded-circle p-0 d-flex justify-content-center align-items-center"
                                        style={{ height: "70px", width: "70px" }}
                                    >
                                        <i className="fas fa-stop fa-2x" />
                                    </Button>
                                )
                            ) :
                                ""
                            }

                        </div>
                    </li>

                    <li className="nav-item">
                        <a href="/mobile/profile" className="nav-link text-center">
                            <i className="fas fa-user fa-lg d-block mb-1" />
                            <span className="small">Akun</span>
                        </a>
                    </li>
                </ul>
            </nav>
            {/* Modal Tutorial Sales Canvasing */}
            <Modal isOpen={modalTutorialCanvasing} toggle={() => setModalTutorialCanvasing(false)}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-title-default">
                        🗺️ Tutorial Sales Canvasing
                    </h5>
                    <button
                        aria-label="Close"
                        className="close"
                        type="button"
                        onClick={() => setModalTutorialCanvasing(false)}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <p><strong>1. Mulai Canvasing:</strong> Klik tombol <Badge color="success">Start</Badge> untuk memulai pencatatan lokasi canvasing.</p>
                    <p><strong>2. Tracking Lokasi:</strong> Lokasi akan dikirim otomatis setiap 1 menit selama status canvasing <Badge color="success">Aktif</Badge>.</p>
                    <p><strong>3. Hold, Resume dan Create:</strong></p>
                    <ul>
                        <li><Badge color="warning"><i className="fas fa-pause" style={{ fontSize: 15 }} /></Badge>: Menjeda pelacakan sementara.</li>
                        <li><Badge color="danger"><i className="fas fa-play" style={{ fontSize: 15 }} /></Badge>: Melanjutkan pelacakan.</li>
                        <li><Badge color="info"><i className="fa fa-plus" style={{ fontSize: 15 }} /></Badge>: Membuat dokumen canvaser.</li>
                    </ul>
                    <p><strong>4. Tambah, Resume dan Create:</strong></p>
                    <ul>
                        <li><Badge color="primary">Tambah</Badge>: wajib menambahkan barang yang mau di order untuk bisa melanjutkan <Badge color="danger"><i className="fas fa-play" style={{ fontSize: 15 }} /></Badge>.</li>
                    </ul>
                    <p><strong>5. Selesai:</strong> Klik <Badge color="danger">Stop</Badge> jika canvasing telah selesai.</p>
                    <p><strong>6. Riwayat:</strong> Klik tombol<strong>📋 Riwayat</strong> untuk melihat histori canvasing Anda.</p>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setModalTutorialCanvasing(false)}>
                        Tutup
                    </button>
                </div>
            </Modal>
            {/* === MODAL UNTUK CEK HARGA ITEM === */}
            <Modal isOpen={isItemModalOpen} toggle={toggleItemModal} size="lg">
                <ModalHeader toggle={toggleItemModal}>
                    <i className="fa fa-search-dollar mr-2" /> Cek Harga Item
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="itemSearch">Cari Nama Item</Label>
                        <Input
                            type="text"
                            name="search"
                            id="itemSearch"
                            placeholder="Ketik nama item..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            autoComplete="off"
                        />
                    </FormGroup>
                    <hr />
                    <h5>Hasil Pencarian:</h5>
                    <div style={{ minHeight: '150px', maxHeight: '300px', overflowY: 'auto', position: 'relative' }}>
                        {isSearching && (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                                <Spinner color="primary">Loading...</Spinner>
                            </div>
                        )}

                        {searchError && !isSearching && (
                            <div className="text-danger text-center mt-3">
                                <i className="fa fa-exclamation-triangle mr-2" />
                                {searchError}
                            </div>
                        )}

                        {/* Ganti bagian ini di dalam ModalBody Anda */}

                        {!isSearching && !searchError && searchResults.length > 0 && (
                            <div className="list-group list-group-flush">
                                {searchResults.map(item => (
                                    <div key={item.id} className="list-group-item d-flex align-items-center p-2">

                                        {/* Bagian Foto Produk */}
                                        <img
                                            // Gunakan URL dari API, atau gambar placeholder jika tidak ada
                                            src={item.image_url === "" || item.image_url === " " || item.image_url === null ? require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default : item.image_url}
                                            alt="#"
                                            className="rounded mr-3" // rounded: sudut membulat, mr-3: margin kanan
                                            style={{ width: '64px', height: '64px', objectFit: 'cover' }}

                                        />

                                        {/* Bagian Detail Produk */}
                                        <div className="flex-grow-1">
                                            <h6 className="mb-1 font-weight-bold text-dark">
                                                {item.item_name || 'Nama Item Tidak Tersedia'}
                                            </h6>
                                            <small className="text-muted d-block">
                                                Satuan: {item.satuan || 'N/A'}
                                            </small>
                                            <div className="font-weight-bold text-success mt-1" style={{ fontSize: '1rem' }}>
                                                {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(item.price || 0)}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {!isSearching && !searchError && searchResults.length === 0 && searchQuery.length > 0 && (
                            <p className="text-muted text-center mt-3">
                                Item tidak ditemukan.
                            </p>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleItemModal}>Tutup</Button>
                </ModalFooter>
            </Modal>
            {/* ================================ */}
            {/* === MODAL UNTUK CEK HARGA ITEM === */}
            <Modal isOpen={isItemModalOpen1} toggle={toggleItemModal1} size="lg">
                <ModalHeader toggle={toggleItemModal1}>
                    <i className="fa fa-search-dollar mr-2" /> Cek Customer
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="itemSearch">Cari Customer </Label>
                        <Input
                            type="text"
                            name="search"
                            id="itemSearch"
                            placeholder="Ketik Nama Customer"
                            value={searchQuery1}
                            onChange={(e) => setSearchQuery1(e.target.value)}
                            autoComplete="off"
                        />
                    </FormGroup>
                    <hr />
                    <h5>Hasil Pencarian:</h5>
                    <div style={{ minHeight: '150px', maxHeight: '300px', overflowY: 'auto', position: 'relative' }}>
                        {isSearching1 && (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                                <Spinner color="primary">Loading...</Spinner>
                            </div>
                        )}

                        {searchError1 && !isSearching1 && (
                            <div className="text-danger text-center mt-3">
                                <i className="fa fa-exclamation-triangle mr-2" />
                                {searchError1}
                            </div>
                        )}

                        {/* Ganti bagian ini di dalam ModalBody Anda */}

                        {!isSearching1 && !searchError1 && searchResults1.length > 0 && (
                            <div className="list-group list-group-flush">
                                {searchResults1.map(item => {
                                    const dynamicLink = `/mobile/canvasing/parent/detail/${item.canvasing_parent_code}`;

                                    return (
                                        <Link
                                            key={item.id}
                                            to={dynamicLink}
                                            className="list-group-item list-group-item-action d-flex align-items-center p-2"
                                            style={{ textDecoration: "none" }}
                                        >
                                            {/* Bagian Detail Produk */}
                                            <div className="flex-grow-1">
                                                <small className="text-muted d-block">
                                                    {item.canvasing_parent_code || "N/A"}
                                                </small>
                                                <h6 className="mb-1 font-weight-bold text-dark">
                                                    {item.customer_name || "Nama Tidak Tersedia"}
                                                </h6>
                                                <small className="text-muted d-block">
                                                    {item.created_at || "N/A"}
                                                </small>
                                                <div
                                                    className="font-weight-bold text-success mt-1"
                                                    style={{ fontSize: "1rem" }}
                                                >
                                                    {item.nama_proyek || "N/A"}
                                                </div>
                                            </div>
                                        </Link>
                                    );
                                })}
                            </div>
                        )}

                        {!isSearching1 && !searchError1 && searchResults1.length === 0 && searchQuery1.length > 0 && (
                            <p className="text-muted text-center mt-3">
                                Item tidak ditemukan.
                            </p>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleItemModal1}>Tutup</Button>
                </ModalFooter>
            </Modal>
            {/* ================================ */}
        </div >
    );
};

export default SalesPage;
